import { render, staticRenderFns } from "./purchasepayement.vue?vue&type=template&id=6a106838"
import script from "./purchasepayement.vue?vue&type=script&lang=js"
export * from "./purchasepayement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports